import template from './faq.html';
import tr from '../../lib/default-translator.js';

class FAQViewModel
{
	constructor(page)
	{
		this.page = page;
	}
}

class FAQPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new FAQViewModel(this);
	}

	init()
	{
		document.title = tr('FAQ');
		window.current_page_title(' ');

		$('.faq_question').click(function () {
			var holder = $(this).parent();

			if (holder.hasClass('open'))
			{
				holder.removeClass('open');
				holder.find('.faq_answer').slideUp();
			} else
			{
				holder.addClass('open');
				holder.find('.faq_answer').slideDown();
			}
		});
	}
}

export default {
	route: '[/]help/faq',
	page_class: FAQPage,
	template: template,
	template_filename: 'translation/faq'
};
